import { FileUploader } from './FileUploader'

export class VideoUploader extends FileUploader {
  constructor({ bucket, bizKey, keyPattern } = {}) {
    if (typeof bucket === 'undefined' || typeof bizKey === 'undefined') {
      throw new Error('[Video Uploader Exception]: {bucket} and {bizKey} is required!')
    }
    super({
      bucket,
      bizKey,
      keyPattern,
    })
  }
}
